import { Box, Typography } from "@mui/material";
import AppStoreLinks from "../../../../components/AppStoreLinks";
import { storePlatform } from "../../../../helpers/storePlatform";
import { onboardingTokens } from "../../theme";
import { t } from "../../../../locales/t";

/**
 * Where to get the mobile app, which is where connections and mentoring live.
 * A phone gets its own store's link; anything else gets QR codes to scan.
 */
const AppDownloadSection = () => {
  const onPhone = storePlatform() !== "other";

  return (
    <Box
      component="section"
      aria-labelledby="done-app-heading"
      sx={{
        p: 3,
        mb: 4,
        borderRadius: "14px",
        backgroundColor: onboardingTokens.card,
        border: `1.5px solid ${onboardingTokens.border}`,
      }}
    >
      <Typography
        id="done-app-heading"
        component="h2"
        sx={{ fontWeight: 700, fontSize: "1.0625rem", mb: 0.75 }}
      >
        {t("onboarding.done.app.heading")}
      </Typography>
      <Typography
        sx={{
          color: onboardingTokens.mutedForeground,
          fontSize: "0.875rem",
          mb: 2.5,
        }}
      >
        {t(
          onPhone
            ? "onboarding.done.app.bodyPhone"
            : "onboarding.done.app.bodyScan",
        )}
      </Typography>
      <AppStoreLinks
        labels={{
          googlePlay: t("onboarding.done.app.googlePlay"),
          appStore: t("onboarding.done.app.appStore"),
          qrGooglePlay: t("onboarding.done.app.qrGooglePlay"),
          qrAppStore: t("onboarding.done.app.qrAppStore"),
        }}
      />
    </Box>
  );
};

export default AppDownloadSection;
